import { getDocs, Query, query, QuerySnapshot, where } from "firebase/firestore";

import { appFaultModel } from "@/core/modules/appFault/models/AppFaultModel";
import { Broker } from "@/features/modules/broker/objects/Broker";
import { brokerModel } from "../BrokerModel";

export const getBrokersWithTrackExpirations = async (): Promise<Broker[]> => {
  try {
    const snapshotQuery: Query<Broker> = query(
      brokerModel.getPathReference().withConverter(brokerModel.firestoreConverter),
      where("trackExpirations", "==", true)
    );

    const snapshot: QuerySnapshot<Broker> = await getDocs(brokerModel.addReadConditionToQuery(snapshotQuery));

    if (snapshot == undefined || snapshot.empty) return [];

    return snapshot.docs.map((doc) => doc.data());
  } catch (error: unknown) {
    appFaultModel.catchAppError("BrokerModel.getBrokersWithTrackExpirations", {}, error);
    return [];
  }
};
